<template>
  <v-container fluid>
    <form>
      <v-text-field v-model="endereco.logradouro" counter maxlength="300">
        <template #label>
          Logradouro
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field v-model="endereco.numero" counter maxlength="15">
        <template #label>
          Número
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field
        v-model="endereco.complemento"
        label="Complemento"
        counter maxlength="150"
      ></v-text-field>
      <v-text-field v-model="endereco.bairro" counter maxlength="200">
        <template #label>
          Bairro
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field v-model="endereco.municipio" counter maxlength="200">
        <template #label>
          Município
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field v-model="endereco.cep" counter maxlength="10">
        <template #label>
          CEP
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field v-model="endereco.uf" counter maxlength="2">
        <template #label>
          UF
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field v-model="endereco.pais" counter maxlength="100">
        <template #label>
          País
          <span class="red--text"><strong> *</strong></span>
        </template></v-text-field
      >
      <v-toolbar elevation="0">
        <v-btn color="orange lighten-3" @click="voltar"> Voltar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-4" @click="salvar"> Salvar </v-btn>
      </v-toolbar>
    </form>
  </v-container>
</template>


<script>
import Endereco from "@/models/endereco";
import * as EnderecoService from "@/services/endereco.service";

export default {
  data() {
    return {
      endereco: new Endereco(),
    };
  },
  mounted() {
    this.loadEndereco();
  },
  methods: {
    voltar() {
      this.$emit("voltar");
    },
    salvar() {
      this.$nprogress.start();
      EnderecoService.create(this.endereco)
        .then((res) => {
          this.$msg.success("Endereço salvo com sucesso!");
          this.endereco = res.data;
          this.$emit("salvou");
        })
        .finally(() => this.$nprogress.done());
    },
    loadEndereco() {
      this.$nprogress.start();
      EnderecoService.getOne()
        .then(
          (res) =>
            (this.endereco = new Endereco(
              res.data.id,
              res.data.logradouro,
              res.data.numero,
              res.data.complemento,
              res.data.bairro,
              res.data.municipio,
              res.data.cep,
              res.data.uf,
              res.data.pais
            ))
        )
        .finally(() => this.$nprogress.done());
    },
  },
};
</script>